import React from 'react';

import Modal from 'antd/es/modal';

import colors from 'config/colors';

import Button from 'components/Button';
import { Link } from 'components/Text';

const EmployeesListModal = ({ modal }) => {
  return (
    <Modal
      title={'Individuals'}
      visible={modal.isVisible}
      onCancel={() => {
        modal.hide();
      }}
      footer={
        <Button onClick={() => {
          modal.hide();
        }}>
          Close
        </Button>
      }
      centered={true}
      keyboard={true}
    >
      {modal.data && modal.data.employees.map((employee, key) =>
        <Link to={`/individuals/${employee.employee_id}`} key={key} style={{ color: colors.primary, display: 'block', paddingBottom: '8px', }}>
          {employee.full_name}
        </Link>
      )}
    </Modal>
  );
};

export default EmployeesListModal;
